import { render, staticRenderFns } from "./profile_form.vue?vue&type=template&id=0a2785a5&lang=pug"
import script from "./profile_form.vue?vue&type=script&lang=js"
export * from "./profile_form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports